/** @jsxImportSource @emotion/react */
import { EuiPageTemplate } from "@inscopix/ideas-eui";
import { PanelProjects } from "components/PanelProjects/PanelProjects";
import { PageOrganizationSideBar } from "./PageOrganizationSidebar";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { CallOutQuotas } from "components/CallOutQuotas/CallOutQuotas";
import { CallOutContract } from "components/CallOutContract/CallOutContract";
import { TenantType } from "types/constants";
import { DemoProjects } from "components/DemoProjects/DemoProjects";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { css } from "@emotion/react";
import { useRef } from "react";
import { HeaderOrganizationDashboard } from "components/HeaderDashboard/HeaderDashboard";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { ToolBrowser } from "components/ToolBrowser/ToolBrowser";
import { ContainerBrowser } from "pages/containers/ContainerBrowser";

export const PageOrganizationDashboard = () => {
  const toolsRoute = useRouteMapContext((s) => s.routeMap.ORGANIZATION_TOOLS);
  const containersRoute = useRouteMapContext(
    (s) => s.routeMap.ORGANIZATION_CONTAINERS,
  );
  const isRouteMatch = useRouteMapContext((s) => s.isRouteMatch);
  const currentTenant = useTenantContext((s) => s.currentTenant);
  const personalSpaceId = useUserContext((s) => s.personalSpace?.id);
  const isPersonalSpace = currentTenant.tenantType === TenantType.PERSONAL;
  const isCurrentUsersPersonalSpace =
    isPersonalSpace && currentTenant.id === personalSpaceId;
  const virtuaScrollRef = useRef<HTMLDivElement>(null);

  return (
    <EuiPageTemplate
      panelled={true}
      bottomBorder={"extended"}
      grow={true}
      mainProps={{
        css: css`
          overflow: auto;
          max-block-size: calc(100vh - var(--euiFixedHeadersOffset, 0));
        `,
      }}
    >
      <CallOutContract format="call_out" />
      <CallOutQuotas />

      <HeaderOrganizationDashboard
        tenantId={currentTenant.id}
        tenantKey={currentTenant.key}
      />

      <EuiPageTemplate.Sidebar minWidth={300} sticky={true}>
        <PageOrganizationSideBar isPersonalSpace={isPersonalSpace} />
      </EuiPageTemplate.Sidebar>

      <div
        style={{
          width: "100%",
          height: "100%",
          overflowY: "auto",
          // opt out browser's scroll anchoring on header/footer because it will conflict to scroll anchoring of virtualizer
          overflowAnchor: "none",
        }}
        ref={virtuaScrollRef}
      >
        {(() => {
          if (isRouteMatch(toolsRoute.parameterizedPath)) {
            return (
              <ToolBrowser
                tenantId={currentTenant.id}
                tenantKey={currentTenant.key}
              />
            );
          } else if (isRouteMatch(containersRoute.parameterizedPath)) {
            return (
              <ContainerBrowser
                tenantId={currentTenant.id}
                tenantKey={currentTenant.key}
              />
            );
          } else {
            return (
              <>
                <PanelProjects
                  tenantId={currentTenant.id}
                  virtuaScrollRef={virtuaScrollRef}
                />
                {isCurrentUsersPersonalSpace && <DemoProjects />}
              </>
            );
          }
        })()}
      </div>
    </EuiPageTemplate>
  );
};
